const DEFAULT_KEY = 'sharethis';
import DB from './_networks-db';

const KEYS = Object.keys(DB);
const KEYS_REGEX = new RegExp(`.*(${KEYS.join('|')}).*`);

const iconFor = (key) => {
  return DB[key] ? DB[key].icon : null;
};

const maskFor = (key) => {
  return DB[key] ? DB[key].mask : null;
};

const colorFor = (key) => {
  return DB[key] ? DB[key].color : null;
};

const keyFor = (url) => {
  if (!url) return DEFAULT_KEY;

  let key = url.replace(KEYS_REGEX, '$1');
  return key === url ? DEFAULT_KEY : key;
};

const keysFor = (urls) => {
  if (!urls || !Array.isArray(urls) || urls.length === 0) return [];

  return urls.map(keyFor);
};

const networks = {
    KEYS: KEYS,
    iconFor: iconFor,
    maskFor: maskFor,
    colorFor: colorFor,
    keyFor: keyFor,
    keysFor: keysFor
};

export default networks;



/** WEBPACK FOOTER **
 ** ./src/components/Icons/networks.js
 **/